export const chapter7 = [

    //page 58
    'At the inner-most depths of Sigg‘s heart their flickered a light,',
    'Hope would not be extinguished, he would not give up the fight,',
    'Sigg‘s body held on to life with a tenacious grasp,',
    'His eyes sprung open, and he sucked in a big gasp,',
    'He struggled to control his panicked breathing and quell the shake,',
    'Bruises, cuts stung all over but at least his head was a numb ache,',
    'In the underbelly of the earth, it was hard to tell if time drifted by,',
    'Sigg drew upon all his resolve to decide he‘d not lay down and die,',
    'He wriggled and twisted and freed up his arms to climb,',
    'After choking on dust, he wiped his face covered in grime,',
    'With a strained heave and all his strength spent,',
    'He failed to move up at all, but he would not relent,',

    //page 59
    '“That upstart conniving trollop!” Rothkuul‘s voice echoed down,',
    '“They dare try to hurt me?! She‘ll pay and the entire town!”,',
    'Sigg could hear a ruckus and a tantrum in progress,',
    'He could not see anything, but he could certainly guess,',
    '“You‘re heading on a journey Iron-jaw, listen to my instruction”,',
    '“Go, summon all the west Gobbo tribes, it’s time for destruction!”,',
    '“All of Cragknoll will suffer my retaliation for this pain”,',
    '“They think they‘ve got one on me? they can think again!”,',
    'Sigg heard some stomping and slamming of doors,',
    'His memory flashed back to the last Gobbo wars,',
    '“I‘ve got to warn them, I have to!” Sigg proclaimed,',
    'But he wasn‘t sure how and felt a little ashamed,',
    'More out of pure frustration than a plan he launched a hard kick,',
    'To his surprise that loosed a rock and looked like it did the trick,',
    'Sigg followed up with several kicks as hard as he could,',
    'It was hard to tell in the darkness if it was doing any good,',
    'He kept at it until every muscle was used up and hurting,',
    'Crack! His legs extended out and water began squirting,',
    '“Yes!” Sigg kicked all the more and soon he‘d unsealed a torrent,',
    'With the gushing sound of water he‘d escape this death warrant,',
    'The rock holding Sigg in place dropped out from underneath,',
    'He fell deep into the ice-cold water and ground his teeth,',

    //page 60
    'Holding on to his air he was tumbled around and about,',
    'As he smacked into rock after rock his life was in doubt,',
    'Gravity‘s victim mid waterfall Sigg stole some precious air,',
    'Plunging into a fast-flowing river he sped to who knows where,',
    'Sigg winced adding to his growing bruise collection,',
    'As the river widened and made another connection,',
    'Now some algae on the cave roof were luminescent, ',
    'Sigg felt the rush of nature’s potent antidepressant,',
    'He now bobbed on the surface with an arm-length above,',
    'Abundant air! it was like the rush of first falling in love,',
    'Sigg did his best at dodging the sides of the cave,',
    'If he could keep this up, he‘d escape a watery grave,',
    'His ears alerted him to the roaring of water ahead,',
    'There was little he could do but go where he was led,',
    'Momentarily airborne he was jettisoned from the mountain side,',
    'If it wasn‘t for the freezing cold and injuries Sigg enjoyed the ride,',
    'Despite the odds he had found his way back under the sky,',
    'The stars hiding behind the clouds above beauty to his eye,',
    'Sigg tried to splash his way to the river‘s edge but failed,',
    'So he grappled his way on to a drifting log, and exhaled,',
    'He rode the river all night until the sun began to peek,',
    'All his efforts were to hold on due to being so weak,',

    //page 61
    'Sigg thought of Cragknoll, but he knew they would not hear him,',
    'Regardless he chose to defend his home despite odds being grim,',
    'The river‘s pace slowed and slowly Sigg floated along,',
    'Just as he was starting to lose his grip he heard a song,',
    'Children from Breglon were playing by the riverbank,',
    'Sigg tried to yell and wave but in doing so nearly sank,',
    'Fatefully one young girl saw him and cried out in alarm,',
    'Moments later two men ran over from a nearby farm,',
    'They leapt into the water and between them they were able to aid,',
    'Minutes later they got Sigg to the shallows and were able to wade,',
    'Upon reaching dry ground Sigg collapsed utterly spent,',
    'But his confidence grew that he would survive this event,',
    'He closed his eyes, his body drank in needed rest,',
    'Sigg focused on the rising and falling of his chest,',
    '“Healer! Healer!” One ran off to get someone to assist,',
    'One of the kids prodded a wound and Sigg made a fist,',
    'The last of his energy gone he fell into a deep sleep,',
    'Early next morning he awoke to the sound of sheep,',
    'Sigg opened his eyes, he lay in a barn with the smell of hay,',
    'He rolled over “He‘s awake!” He heard a familiar voice say, ',
    'Sigg looked over to see Garson with a relieved facial expression,',
    '“I barely recognized you without armour! and I have a question”,',

    //page 62
    '“What the hell happened to you?! I thought you were going home?!”,',
    'Sigg returned a smile, “I thought so too, I narrowly avoid my catacomb”,',
    'He sat up and checked his injuries they wrapped well in linen,',
    'Sigg spoke softly “Garson are you able to help me stop a villain?”,',
    '“There is an army of Gobbos marching east right now”,',
    'He clenched a fist “This is something I will not allow”,',
    '“Alright! Slow down. Perhaps you should eat a morning meal?”,',
    'Sigg took a breath “Yes, I‘m famished, and that‘ll help me heal”,',
    'Garson helped him get up and they walked outside,',
    'They followed their noses of some meat being fried,',
    'They sat at a wood table outside the inn, in the warm sunshine,',
    'Their hot food arrived to happy faces and they began to dine,',
    'At that moment Andell walked over with three jugs of ale,',
    '“Glad you‘re awake!” She sat down and Sigg told them the tale,',
    'Once they were both up to speed Sigg asked Andell,',
    '“But how did you get here so fast? please do tell”,',
    'She drew a small stone out of her pocket, Garson did the same,',
    '“As soon Garson found you washed up, he called me and I came”,',
    '“Clearly I‘ve not spent enough time talking to a stone!”,',
    'Andell laughed. “No its listening that you need to hone”,',
    'Sigg continued “…so you see I must protect my homeland”,',
    '“If you are both available, I could really use a helping hand”,',

    //page 63
    '“Is there a town guard nearby we can somehow rally?”',
    'Andell replied, “No, closest would miles east of the valley”,',
    'They all stood after finishing up their drinks “Let’s begin!”,',
    'Garson smiled, “Are you going to fight in naught but your skin?”,',
    '“Ah yes. I‘ll need weapons too. Where is the quartermaster?”,',
    '“There is a pile from the dead bandits, it‘ll probably be faster”,',
    '“Bandits?” Andell asked, she looked surprized,',
    '“You two have been up to more than I realized!”',
    'By midday Sigg stood clad in the best of bandit leather,',
    'They packed a few travel bags, then set off together,',
    '“This wasn‘t made in Cragknoll that much is clear”,',
    'But Sigg hoped it would still stop a Gobbo‘s spear,',
    'He checked the pair of swords he chose to carry,',
    'A bit of edge damage but could still cut and parry,',
    '“Is your body up for more insult?” Andell asked concerned,',
    'Sigg just replied with a confident nod which she returned,',
    'The three fleshed out their plan as they travelled on their trek,',
    'With numbers not on their side they needed to stack the deck,',
    '“Gobbos are cruel, with no pity, morals or a shred of compassion”,',
    'Sigg described his mortal foe and their tactics in detailed fashion,',
    '“We need to stop them before Cragknoll‘s outer gate, -our mission”,',
    '“I hope that with a bit of cunning we can exploit their superstition”,',

    //page 64
    'Sigg finished explaining and with a hopeful look awaited feedback,',
    'Garson looked concerned, “We‘ll need be ready for a counterattack”,',
    'Andell too had a worried look on her face, “I‘ll ask the forest to support”,',
    '“Here take some of my sleep-block in case need it for a last resort”,',
    'She passed a few vials smelling of lavender and chives,',
    '“We‘ll need every advantage to keep hold of our lives”,',
    '“I‘ve got some new tools prepared that‘s a bit more mechanical”,',
    'Garson gestured to his pack “Lets end this evil one most tyrannical”,',
    'So the three continued on the path towards Cragknoll ready for combat,',
    'They were willing to give their lives, but hoped it wouldn‘t come to that,',
    'Past the fields, following the river clouds gathered overhead,',
    'It was if the sky knew soon so many would end up dead,',
    'They did not slow, stop for a rest and marched on to their fate,',
    'Their plan hinged on stopping the Gobbo‘s before the outer gate,',
    'Finally they reached the pine forest entering they lost the sun‘s heat,',
    'The three continued on the neglected path with leaves under their feet,',
    'After they had trekked deeper Sigg held up a hand “We go north”,',
    'They departed the trail, stomping through bracken thenceforth,',
    '“I expect the Gobbo army will be somewhere north of the pines”,',
    '“But just to be safe, let’s keep quiet and be on the lookout for signs”,',
    'They stalked through forest keeping a diligent lookout,',
    'And to their surprize it paid off as they spotted a scout,',

    //page 65
    'Gobbos are an unsightly creature wrapped in leathery skin,',
    'Not as tall as a man, perhaps a reptile in their ancestral kin,',
    'The single Gobbo made its way south with a spear in its hand,',
    'On its scraps of clothing, it wore the ‚Many Teeth‘ tribal brand,',
    'Sigg had trouble containing his rage against one of this bloody clan,',
    'He gripped his blade with white knuckles and almost forgot his plan,',
    'Garson ducked behind a bush and assembled his latest prototype,',
    'After loading a bundle of darts, applying oil he was ready to snipe,',
    'Andell was further from the Gobbo than Sigg but out of its view,',
    'She slinked through the green shrubs and the scout had no clue,',
    'Eager for pay back for crimes and pain of the past,',
    'Sigg hurried through the bushes, but went too fast,',
    'The snap of a twig caused the Gobbo to look over in Sigg‘s direction,',
    'Andell leapt from her position and stabbed her blade into its midsection,',
    'Before it could cry out in alarm a follow up slice across its neck,',
    'Scouts would often travel in pairs they would have to double check,',
    'Trigger pressed, a rush of air and the cycle of a bolt,',
    'An obscured Gobbo‘s head snapped back with a jolt,',
    '“Got one!” Garson hissed as he noted the result in his manuscript,',
    'Both Andell and Sigg returned grateful looks but kept tight-lipped,',
    'They spent a few moments waiting for more staying concealed,',
    'Their ears attentive to every forest sound and eyes were peeled,',

    //page 66
    'Sigg gave a hand signal and they gathered near,',
    '“Scouts this far south means things are severe”,',
    '“We need to accelerate the plan they are further than I thought”,',
    '“I was hoping more time to prepare an ambush before we fought”,',
    'Andell cleaned her hunting knife upon the rags of her kill,',
    '“We will win the day Sigg, they have numbers but no skill”,',
    '“Bring the other body here, I have an idea“ Sigg requested,',
    'They killed each other -was what the bodies now suggested,',
    '“Will they really go for that?” Garson out loud wondered,',
    '“Probably not, but hopefully it will slow down the hundred”,',
    'After a scan of the bushes ahead, they pressed north once more,',
    'In just a short distance they heard the march of Gobbos by the score,',
    'They dove into the bushes and Sigg managed a peek,',
    'To take them all on here they chances would be bleak,',
    '“Pssst Andell“ Sigg whispered “When ready do as we planned”,',
    'She nodded then made a series of signals with her right hand,',
    'A moment later a black crow flew high above them through the trees,',
    'It soared above the Gobbos and relayed thoughts to Andell -at unease,',
    '“Sigg, such numbers we cannot defeat by force of arms”,',
    '“Shall we retreat, and plea at the gates to raise alarms?”,',
    '“I hear you, let’s keep that as a last resort, they‘re unskilled remember?”,',
    'Sigg wondered if the Cragknollian guards still consider him a member?',

    //page 67
    '“Phase one! let’s go”, Sigg motioned with his hands and directed, ',
    'The enemy was numerous and moving faster than he expected,',
    'The crow flew back around full speed into a tree and its neck broke,',
    'Its body fell just in front of the Gobbo lines, like the forest just spoke,',
    'A chatter erupted as the Gobbo shaman was called for,',
    'It was ritual to the consult the bones on march to war,',
    'As the Gobbo troops came to a halt one of them spotted Andell,',
    'The creature pointed its spear, those near rushed and began to yell,',
    'She darted back through the trees dodging left and right,',
    'Andell then stopped behind a bush and got ready to fight,',
    'The horde of Gobbos began to charge forward, but were stopped,',
    'The Shaman‘s staff stamped twice where the crow had dropped,',
    'A combat pack of Gobbos were permitted to pursue,',
    'Sigg and Garson sank into the foliage saw the view,',





];